import React from "react";
import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";
import TextEditor from "../../components/srf/textEditor";
import axiosWithToken from "./axiosTokenConfig";
import moment from "moment"; // Make sure moment is installed or import accordingly
import { BASE_URL } from "../../global";
import SendEmailButton from "./sendEmailButton";

// DescriptionValue now returns a function to dynamically replace the placeholders with selectedColumn values
const DescriptionValue = {
  srf: (selectedColumn) => `
    <p><br></p>
    <p>Thanks for your business with us. We have received your instruments against your challan No: for calibration Details</p>
    <p><br></p>
    <p>Job No: ${selectedColumn.serviceReqNumber},</p>
    <p>Purchase Order No: ${selectedColumn.poNumber},</p>
    <p>Receipt Date: ${selectedColumn.receiptDate},</p>
    <p>DC/RGP Number: ${selectedColumn.dcNumber},</p>
    <p>DC/RGP Date: ${selectedColumn.dcDate},</p>
    <p>Entry Date: ${selectedColumn.entryDate},</p>
    <p>Committed Delivery Date: ${selectedColumn.committedDeliveryDate},</p>
    <p><br></p>
    <p>Please feel free to contact us in case of any queries, Expecting your valuable order.</p>
    <p><br></p>
    <p>Thanks & Regards,</p>
    <p>Er. Pravin Kashid</p>
    <p>(Founder)</p>
    
    <p><br></p>
    <p>Regd. Office: 129, Vindya Complex, Sector-11,</p>
    <p>CBD Belapur Navi Mumbai, Maharashtra.</p>
    <p>Contact: 9769847865</p>
    <p>Website: <a href="https://bfiinfotech.co.in/" target="_blank" rel="noopener noreferrer">bfiinfotech.co.in</a></p>
    
  `,

  invoice: (selectedColumn) => `
    <p><br></p>
    <p><strong>Greetings from BFI </strong></p>
    <p><br></p>
    <p>Regarding your inquiry <strong>(No-${
      selectedColumn.enquiryId
    } dated ${moment(selectedColumn.enquiryDate).format(
    "YYYY-MM-DD"
  )})</strong>, please find the enclosed Invoice <strong>(Invoice No: ${
    selectedColumn.invoiceNumber
  } Dated ${selectedColumn.date})</strong> for Calibration Charges.</p>
    <p>Subject: ${selectedColumn.subject},</p>
    <p>Equipment Collection: ${selectedColumn.equipmentCollection},</p>
    <p>Equipment Delivery: ${selectedColumn.equipmentDelivery},</p>
    <p>Total Quantity: 12,</p>
    <p>Grand Total: ${selectedColumn.totalAmount},</p>
    <p>Onsite Charges: ${selectedColumn.conveyanceCharges},</p>
    <p>Courier Charges: ${selectedColumn.courierCharges},</p>
    <p><br></p>
    <p>Please feel free to contact us in case of any queries, Expecting your valuable order.</p>
    <p><br></p>
    <p>Thanks & Regards,</p>
    <p>Er. Pravin Kashid</p>
    <p>(Founder)</p>
    
    <p><br></p>
    <p>Regd. Office: 129, Vindya Complex, Sector-11,</p>
    <p>CBD Belapur Navi Mumbai, Maharashtra.</p>
    <p>Contact: 9769847865</p>
    <p>Website: <a href="https://bfiinfotech.co.in/" target="_blank" rel="noopener noreferrer">bfiinfotech.co.in</a></p>
    
  `,

dispatch: (selectedColumn) => `
  <p><br></p>
  <p><strong>Greetings from Recon Calibration &amp; Test Labs LLP! </strong></p>
  <p><br></p>
  <p>We are pleased to inform you that the calibration of your instruments has been successfully completed.</p>
  <p>The calibrated instruments, along with their respective calibration certificates, have been dispatched today via <strong>${selectedColumn.dispatchMedium || "[Dispatch Medium]"}</strong>.</p>
  <p><strong>Dispatch Details:</strong></p>
  <ul>
    <li><strong>Client Name:</strong> ${selectedColumn.companyName || "[Customer/Lab Name]"}</li>
    <li><strong>Service Request Number:</strong> ${selectedColumn.serviceRequestNumber || ""}</li>
    <li><strong>Delivery Challan No:</strong> ${selectedColumn.deliveryChallanNo || ""}</li>
    <li><strong>Date of Dispatch:</strong> ${selectedColumn.dispatchDate || ""}</li>
    <li><strong>Mode of Dispatch:</strong> ${selectedColumn.dispatchMode || "[Courier/Hand Delivery]"}</li>
    <li><strong>No. of Instruments:</strong> ${selectedColumn.instrumentCount || ""}</li>
  </ul>
  <p><br></p>
  <p>Thanks & Regards,</p>
  <p>Er. Pravin Kashid</p>
  <p>(Founder)</p>
  
  <p><br></p>
  <p>Regd. Office: 129, Vindya Complex, Sector-11,</p>
  <p>CBD Belapur Navi Mumbai, Maharashtra.</p>
  <p>Contact: 9769847865</p>
  <p>Website: <a href="https://bfiinfotech.co.in/" target="_blank" rel="noopener noreferrer">bfiinfotech.co.in</a></p>
  
`,

  quotation: (selectedColumn) => {
    if (selectedColumn.enquiryId && selectedColumn.enquiryDate) {
      return `
        <p><br></p>
        <p><strong>Greetings from BFI </strong></p>
        <p><br></p>
        <p>Regarding your inquiry <strong>(No-${
          selectedColumn.enquiryId
        } dated ${moment(selectedColumn.enquiryDate).format(
        "YYYY-MM-DD"
      )})</strong>, please find the enclosed quotation <strong>(Quotation No: ${
        selectedColumn.quotationNumber
      } Dated ${selectedColumn.date})</strong> for Calibration Charges.</p>
        <p><br></p>
        <p>Subject: ${selectedColumn.subject},</p>
        <p>Equipment Collection: ${selectedColumn.equipmentCollection},</p>
        <p>Equipment Delivery: ${selectedColumn.equipmentDelivery},</p>
        <p>Total Quantity: 12,</p>
        <p>Grand Total: ${selectedColumn.totalAmount},</p>
        <p>Onsite Charges: ${selectedColumn.conveyanceCharges},</p>
        <p>Courier Charges: ${selectedColumn.courierCharges},</p>
        <p><br></p>
        <p>Please feel free to contact us in case of any queries, Expecting your valuable order.</p>
        <p><br></p>
        <p>Kindly confirm the receipt of the mail. While sending the Instrument, send all accessories (cables, power cord, etc.) along with the instruments for calibration.</p>
        <p><br></p>
        <p>Thanks & Regards,</p>
        <p>Er. Pravin Kashid</p>
        <p>(Founder)</p>
        
        <p><br></p>
        <p>Regd. Office: 129, Vindya Complex, Sector-11,</p>
        <p>CBD Belapur Navi Mumbai, Maharashtra.</p>
        <p>Contact: 9769847865</p>
        <p>Website: <a href="https://bfiinfotech.co.in/" target="_blank" rel="noopener noreferrer">bfiinfotech.co.in</a></p>
        
      `;
    } else {
      return `
        <p><br></p>
        <p><strong>Greetings from BFI </strong></p>
        <p><br></p>
        <p>Please find the enclosed quotation <strong>(Quotation No: ${selectedColumn.quotationNumber} Dated ${selectedColumn.date})</strong> for Calibration Charges.</p>
        <p><br></p>
        <p>Subject: ${selectedColumn.subject},</p>
        <p>Equipment Collection: ${selectedColumn.equipmentCollection},</p>
        <p>Equipment Delivery: ${selectedColumn.equipmentDelivery},</p>
        <p>Total Quantity: 12,</p>
        <p>Grand Total: ${selectedColumn.totalAmount},</p>
        <p>Onsite Charges: ${selectedColumn.conveyanceCharges},</p>
        <p>Courier Charges: ${selectedColumn.courierCharges},</p>
        <p><br></p>
        <p>Please feel free to contact us in case of any queries, Expecting your valuable order.</p>
        <p><br></p>
        <p>Kindly confirm the receipt of the mail. While sending the Instrument, send all accessories (cables, power cord, etc.) along with the instruments for calibration.</p>
        <p><br></p>
        <p>Thanks & Regards,</p>
        <p>Er. Pravin Kashid</p>
        <p>(Founder)</p>
        
        <p><br></p>
        <p>Regd. Office: 129, Vindya Complex, Sector-11,</p>
        <p>CBD Belapur Navi Mumbai, Maharashtra.</p>
        <p>Contact: 9769847865</p>
        <p>Website: <a href="https://bfiinfotech.co.in/" target="_blank" rel="noopener noreferrer">bfiinfotech.co.in</a></p>
        
      `;
    }
  },
};

const RenderEmailModal = ({
  open,
  handleClose,
  selectedColumn,
  refresh,
  formType,
  emailDescription,
}) => {
  const [formData, setFormData] = React.useState({
    userEmail: "",
    clientName: selectedColumn?.clientName || "",
    subject: "",
    cc: "",
  });

  const [editorValue, setEditorValue] = React.useState(null);
  const [emailIds, setEmailIds] = React.useState([]);



  const handleEditorChange = (value) => {
    setEditorValue(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    try {
      let payload = {
        userEmail: formData.userEmail,
        clientName: formData.clientName,
        subject: formData.subject,
        description: editorValue,
        cc: formData.cc,
      };

      await axiosWithToken.post(BASE_URL + `email`, payload);
      setTimeout(refresh, 500);
      toast("Email sent successfully!");
      handleClose();
    } catch (err) {
      toast.error("Error occurred while sending email.");
    }
  };

  const getClientContacts = (clientID) => {
    const url = BASE_URL + "dynamic";

    const payload = {
      query: `SELECT contact FROM clients WHERE id = ${clientID}`,
    };

    return axiosWithToken
      .post(url, payload)
      .then((res) => {
        const contactData = res.data?.[0]?.contact;
        const contacts = contactData ? JSON.parse(contactData) : [];

        const emailIds = contacts
          .map((c) => c.emailId?.trim().toLowerCase())
          .filter((email) => !!email); // removes undefined or empty

        setEmailIds(emailIds);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          console.error("Error fetching client contacts:", err);
          toast.error("Error fetching client contacts.");
        }
        return []; // return empty array on error
      });
  };

  React.useEffect(() => {
    if (selectedColumn?.clientId) getClientContacts(selectedColumn?.clientId);
  }, [selectedColumn?.clientId]);

  React.useEffect(() => {
    if (emailDescription) {
      setEditorValue(emailDescription);
    } else if (selectedColumn && formType) {
      setEditorValue(DescriptionValue[formType](selectedColumn));
    }
  }, [selectedColumn, formType, emailDescription]);

  React.useEffect(() => {
    if (emailIds?.length) {
      setFormData((prev) => ({
        ...prev,
        userEmail: emailIds[0] || "",
        cc: emailIds.slice(1).join(",") || "",
      }));
    }
  }, [emailIds]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          width: 800,
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h5" mb={2}>
          Email Form
        </Typography>
        {/* <TextField
          label="From"
          fullWidth
          name="clientName"
          value={formData.clientName}
          onChange={handleChange}
          sx={{ marginBottom: "20px" }}
        /> */}
        <TextField
          label="To"
          fullWidth
          name="userEmail"
          value={formData.userEmail}
          onChange={handleChange}
          sx={{ marginBottom: "20px" }}
        />
        <TextField
          label="CC"
          fullWidth
          name="cc"
          value={formData.cc}
          onChange={handleChange}
          sx={{ marginBottom: "20px" }}
        />
        <TextField
          label="Subject"
          fullWidth
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          sx={{ marginBottom: "20px" }}
        />

        <TextEditor value={editorValue} onChange={handleEditorChange} />

        <Box sx={{ marginTop: "20px", textAlign: "right" }}>
          <SendEmailButton
            emailObject={{
              userEmail: formData.userEmail,
              from: formData.clientName,
              subject: formData.subject,
              description: editorValue,
              cc: formData.cc,
            }}
          />
          {/* <Button variant="contained" color="primary" onClick={handleSubmit}>
            Send Email
          </Button> */}
        </Box>
      </Box>
    </Modal>
  );
};

export default RenderEmailModal;
